import { BUSINESS_IDENTIFIER, USER_ROLES } from './api/const';

export const IS_SPAIN_ENV = APPLICATION_BUSINESS_IDENTIFIER === BUSINESS_IDENTIFIER.ES_BAYTECA;

export const IS_UAE_ENV = APPLICATION_BUSINESS_IDENTIFIER === BUSINESS_IDENTIFIER.AE_HUSPY;

const AE = 'AE';
const ES = 'ES';

export const ENV_COUNTRY_ALPHA_2_CODE = IS_SPAIN_ENV ? ES : AE;

export const ENV_DEFAULT_LANGUAGE = IS_SPAIN_ENV ? 'es' : 'en';

const COUNTRY_ROLE_MAP: { [key: string]: string } = {
  AE: USER_ROLES.broker,
  ES: USER_ROLES.brokerEs,
};

export const CURRENT_USER_ROLE: string = COUNTRY_ROLE_MAP[ENV_COUNTRY_ALPHA_2_CODE] || '';

export const getClientVaultUrl = (opportunityId: string) =>
  `${VAULT_URL}/login/${opportunityId}?lang=${ENV_DEFAULT_LANGUAGE}`;

export const getClientVaultDigitalProposalUrl = (proposalId: string) =>
  `${VAULT_URL}/proposal/${proposalId}?lang=${ENV_DEFAULT_LANGUAGE}&time=${new Date().toISOString()}`;

export const slidoDeepLink = {
  CASE_CREATION: 'slido-case-creation',
  PROPOSAL_CREATION: 'slido-proposal-creation',
  CLIENT_CREATION: 'slido-client-creation',
  BUY_CREDIT: 'slido-buy-credit',
  REFER_AND_EARN: 'slido-refer-and-earn',
  TERMS_AND_CONDITIONS: 'slido-terms-and-condition',
};
